const CircleQuestionIcon = ({ ...props }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.00156 1.6001C4.46694 1.6001 1.60156 4.46548 1.60156 8.0001C1.60156 11.5347 4.46694 14.4001 8.00156 14.4001C11.5362 14.4001 14.4016 11.5347 14.4016 8.0001C14.4016 4.46548 11.5362 1.6001 8.00156 1.6001ZM7.31585 11.4668C7.31585 11.8455 7.62285 12.1525 8.00156 12.1525C8.38027 12.1525 8.68728 11.8455 8.68728 11.4668C8.68728 11.0881 8.38027 10.7811 8.00156 10.7811C7.62285 10.7811 7.31585 11.0881 7.31585 11.4668ZM6.97299 6.8001C6.97299 6.23203 7.4335 5.77153 8.00156 5.77153C8.56963 5.77153 9.03013 6.23203 9.03013 6.8001C9.03013 7.36816 8.56963 7.82867 8.00156 7.82867C7.62285 7.82867 7.31585 8.13568 7.31585 8.51439V9.4097C7.31585 9.78841 7.62285 10.0954 8.00156 10.0954C8.38027 10.0954 8.68728 9.78841 8.68728 9.4097V9.10071C9.67864 8.80567 10.4016 7.88731 10.4016 6.8001C10.4016 5.47462 9.32705 4.4001 8.00156 4.4001C6.67608 4.4001 5.60156 5.47462 5.60156 6.8001C5.60156 7.17881 5.90857 7.48581 6.28728 7.48581C6.66599 7.48581 6.97299 7.17881 6.97299 6.8001Z"
        fill="#7E7E8B"
      />
    </svg>
  );
};

export default CircleQuestionIcon;
